// extracted by mini-css-extract-plugin
export var returnButton = "betalingvoltooid-module--return-button--0b894";